import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Chart from './Chart';
import Deposits from './Deposits';
import AdminOrders from '../../AdminPage/AdminOrder';
import { GetAllOrder } from '../../services/ApiServices/OrderService';

const ChartPage = ({ setLoading }) => {
  const [orders, setOrders] = useState([]);

  const fetchOrders = async () => {
    try {
      const data = await GetAllOrder();
      setOrders(data);
    } catch (err) {
      console.error('Error fetching orders:', err);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mb: 4 }}>
      <Grid container spacing={3}>
        {/* Chart */}
        <Grid item xs={12} md={8} lg={9}>
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              height: 500,
              width: 830,
            }}
          >
            <Chart orders={orders} />
          </Paper>
        </Grid>
        {/* Recent Deposits */}
        <Grid item xs={12} md={4} lg={3}>
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              height: 130,
            }}
          >
            <Deposits orders={orders} />
          </Paper>
        </Grid>
        {/* Recent Orders */}
        <Grid item xs={12}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <AdminOrders setLoading={setLoading} filterStatus="Đã thanh toán" />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ChartPage;
